<template>
  <div class="content">
    <h1 class="has-text-centered">Nützliche Programme für Elektrotechnik-Projekte</h1>
    <div class="box">
      <div class="columns">
        <div class="column is-half has-text-centered">
          <img class="max-width-280 screenshot" src="@/assets/images/software/kicad.png">
        </div>
        <div class="column is-half is-size-7-mobile">
          <h2 class="is-size-4-mobile">KiCad</h2>
          <div class="tags">
            <span class="tag">Desktop (Linux)</span>
            <span class="tag">Desktop (Windows)</span>
            <span class="tag">Desktop (MacOS)</span>
            <span class="tag">Desktop (FreeBSD)</span>
          </div>
          <p>
            KiCad ist ein freies ECAD-Programmpaket zur Entwicklung von Leiterplatten in der Elektronik. Es wird von einer Gruppe von freiwilligen Entwicklern und zwei Wissenschaftlern des CERN entwickelt und ist für Linux, Windows, MacOS und FreeBSD verfügbar.
          </p>
          <p class="has-text-centered">
            <a class="button is-primary" href="https://www.kicad.org/" target="_blank">Webseite öffnen</a>
          </p>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="columns">
        <div class="column is-half has-text-centered">
          <img class="max-width-280 screenshot" src="@/assets/images/software/freecad.jpg">
        </div>
        <div class="column is-half is-size-7-mobile">
          <h2 class="is-size-4-mobile">FreeCAD</h2>
          <div class="tags">
            <span class="tag">Desktop (Linux)</span>
            <span class="tag">Desktop (Windows)</span>
            <span class="tag">Desktop (MacOS)</span>
          </div>
          <p>
            FreeCAD ist eine 3D-CAD-Software, die im Quellcode und Programm als freie Software verfügbar ist.
          </p>

          <p class="has-text-centered">
            <a class="button is-primary" href="https://www.freecadweb.org/" target="_blank">Webseite öffnen</a>
          </p>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="columns">
        <div class="column is-half has-text-centered">
          <img class="max-width-280 screenshot" src="@/assets/images/software/ltspice.png">
        </div>
        <div class="column is-half is-size-7-mobile">
          <h2 class="is-size-4-mobile">LTspice</h2>
          <div class="tags">
            <span class="tag">Desktop (Windows)</span>
            <span class="tag">Desktop (MacOS)</span>
          </div>
          <p>
            LTspice ist eine kostenlose Software des ehemaligen Halbleiterherstellers Linear Technology (seit 2017: Analog Devices) zur Schaltungssimulation. Es basiert auf SPICE, ist dazu kompatibel und besonders zur Simulation von Schaltnetzteilen geeignet.
          </p>
          <p class="has-text-centered">
            <a class="button is-primary" href="https://www.analog.com/en/design-center/design-tools-and-calculators/ltspice-simulator.html" target="_blank">Webseite öffnen</a>
          </p>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="columns">
        <div class="column is-half has-text-centered">
          <img class="max-width-280 screenshot" src="@/assets/images/software/everycircuit.png">
        </div>
        <div class="column is-half is-size-7-mobile">
          <h2 class="is-size-4-mobile">EveryCircuit</h2>
          <div class="tags">
            <span class="tag">Desktop (Web)</span>
            <span class="tag">Smartphone (Android)</span>
            <span class="tag">Smartphone (iOS)</span>
          </div>
          <p>
            Interaktive Schaltungssimulationen in Echtzeit. Die App läuft auf allen wichtigen Mobil- und Desktop-Plattformen (Android, iOS, Windows, Mac & Linux) und ermöglicht eine nahtlose Synchronisierung zwischen den Geräten über die EveryCircuit-Cloud.
          </p>
          <p class="has-text-centered">
            <a class="button is-primary" href="https://everycircuit.com/" target="_blank">Webseite öffnen</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ee-software',
  metaInfo: {
    title: 'Elektrotechnik Programme | Elektrotechik-Rechner.at',
    meta: [
      {
        name: 'description',
        content: 'Schaltungs-, Logiksimulationen, PCB Design, CAD uvm. Hier findest du eine Liste mit Programmen.'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: 'Programme', route: 'start' })
  }
}
</script>
